import React, { Component } from "react";
import MainPicture from "../Section/MainPicture";
import image from './img/site-internet-responsive.png';
import LeftPictureBackground from "../Section/LeftPictureBackground";
import picturemethodo from "./img/e-marketing.png";
import picturequality from "./img/referencement-seo-som.png";
import RightPicture from "../Section/RightPicture";
import CheckModule from "../Section/CheckModule";
import pictureevol from "./img/site-designe.png";
import technologies from "../../../static/images/technologies.png";
import symfony from "../../pages/img/symfony.png";
import nodejs from "./img/nodejs.png";
import angular from "./img/angular-react.png";
import database from "./img/base-de-donnee.png";
import elasticsearch from "./img/elasticsearch.png";
import html from "./img/html-css-js.png";

class SiteInternetApp extends Component {
  render() {
    let goto = "En découvrir plus";
    let alt = "La vitrine de votre activité Internet";
    let description = 

    ["Nous réalisons des sites Internet, véritable vitrine de votre activité, sur-mesure et optimisés pour le référencement.", <br/>,
"En plus de créer des sites sublimes, nous apportons un soin tout particulier sur l'optimisation et l'ergonomie."];
    let smalltitle = "Vous avez la main sur votre communication !";
    let titlemethodo = "Vous êtes autonomes";
    let descriptionmethodo = [
        "Nous proposons plusieurs choix à nos clients pour le pilotage de leurs sites internet.", <ul><li><strong>Une autonomie totale à travers un espace d'administration</strong><p>Vous souhaitez piloter votre communication de A à Z, c'est possible !</p></li><li><strong>Nous nous occupons des mises à jour pour vous.</strong><p>Vous n'avez pas le temps, vous ne savez pas faire, on s'occupe de tout !</p></li></ul>,

    ];
    let pictureMethodo = picturemethodo;
    let altmethodo = "Méthodologie agile Scrum en image";



    let smalltitleevol = "Design et Ergonomie font bon ménage";
    let titleevol = "Une ergonomie réfléchie";
    let descriptionevol = [
        "Nous travaillons avec nos graphistes web afin d'", <strong>imaginer un site vitrine</strong>, " entièrement à votre image.",<br />, <br/>,
        "Nous mettons notre expérience à votre service pour proposer une ergonomie efficace !", <br />, <br />, " Toutes les organisations sont différentes, c'est pourquoi nous ne réalisons que des sites Internet sur-mesure !"

    ];
    let altevol = "Intégration du portail dans votre système d'information";


    let smalltitleCheck = "Le référencement naturel au coeur de votre site" ;
    let titleCheck = "On optimise votre site pour le positionnement dans les moteurs de recherche";
    let subtitle1Check = "Les bonnes pratiques";
    let text1Check = ["Nous mettons en place l'ensemble des recommandations et bonnes pratiquent du moteur de Recherche de Google pour votre ",<strong>référencement naturel</strong>,"." ];
    let subtitle2Check = "Un site rapide";
    let text2Check = "Nous développons des sites rapides et compatibles avec les tablettes et smartphones (Responsive). L'optimisation est au coeur de nos réalisations !";
    let subtitle3Check = "Les conseils";
    let text3Check = "Au-delà de l'aspect technique, le contenu de votre site est primordial dans le référencement. Nous vous accompagnons et conseillons pour que le contenu de votre site réponde aux critères qualitatifs nécessaires à un référencement de qualité.";
    let pictureCheck = picturequality;
    let altCheck = "Référencemnent et SEO";



    return (
      <div className="generic-services">
        <MainPicture title="Création de site Internet de qualité" description={description} picture={image} alt={alt} />
        <RightPicture smalltitle={smalltitleevol} title={titleevol} description={descriptionevol} picture={pictureevol} alt={altevol} />
        <LeftPictureBackground smalltitle={smalltitle} title={titlemethodo} description={descriptionmethodo} picture={pictureMethodo} alt={altmethodo} />
        <CheckModule 
                smalltitle={smalltitleCheck} 
                title={titleCheck}
                subtitle1={subtitle1Check}
                text1={text1Check}
                subtitle2={subtitle2Check}
                text2={text2Check}
                subtitle3={subtitle3Check}
                text3={text3Check}
                picture={pictureCheck}
                alt={altCheck}
        />
      </div>
    );
  }
}

export default SiteInternetApp;



// WEBPACK FOOTER //
// ./src/components/Page/SiteInternetApp.jsx